import { Box, Grid, makeStyles, Paper, Button } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { getUsersOrders } from "../../../../redux-store/books/actions";
import { Pagination } from "@mui/material"; // Import Pagination
import { Download } from "@mui/icons-material";

const useStyles = makeStyles((theme) => ({
  root: {
    border: `1px solid ${theme.palette.secondary.dark}`,
    borderRadius: "5px",
    marginTop: "30px",
    marginBottom: "30px",
    padding: "10px",
    [theme.breakpoints.down("md")]: {
      marginTop: "30px",
    },
  },
  tabHeading: {
    fontSize: "32px",
    fontWeight: 550,
    margin: "0",
  },
  userName: {
    color: theme.palette.primary.dark,
    fontSize: 22,
    fontWeight: 500,
  },
  subHead: {
    margin: 0,
    fontSize: 18,
    fontWeight: 550,
    width: "150px",
  },
  contactBox: {
    display: "flex",
    flexWrap: "wrap",
    padding: "8px 0",
    margin: "0px",
    borderBottom: `1px solid ${theme.palette.secondary.dark}`,
  },
  paper: {
    padding: 5,
    textAlign: "center",
  },
}));

function Books() {
  const classes = useStyles();
  const { currentUser } = useSelector((state) => state.auth);
  const { orders, loading, error } = useSelector((state) => state.userOrders);
  const [books, setBooks] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const booksPerPage = 8; // Number of books per page
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(getUsersOrders(currentUser._id));
  }, [dispatch, currentUser._id]);

  useEffect(() => {
    if (orders) {
      setBooks(orders);
    }
  }, [orders]);

  // Get current books
  const indexOfLastBook = currentPage * booksPerPage;
  const indexOfFirstBook = indexOfLastBook - booksPerPage;
  const currentBooks = books
    .filter((order) => order.book_price && Object.keys(order.book_price)[0] === "digital_price")
    .filter((order) => order.book?.pre_order === false)
    .slice(indexOfFirstBook, indexOfLastBook);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };
  const handleDownload = (pdfUrl) => {
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.setAttribute('download', 'filename.pdf'); // You can set the filename here
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className={classes.root}>
  <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
    <h2 className={classes.tabHeading}>My Books</h2>
  </Box>
  {loading ? (
    <Skeleton animation="wave" />
  ) : currentBooks.length > 0 ? (
    <>
      <Grid container spacing={2}>
        {currentBooks.map((order, index) => (
          <Grid item xs={12} md={4} lg={3} key={index}>
            <Link to="#" style={{ textDecoration: "none" }}>
              <Paper elevation={2} className={classes.paper}>
                <Box style={{ width: "90%", margin: "0 auto" }}>
                  <img
                    src={order.book?.book_cover}
                    alt={order.book?.book_title}
                    style={{
                      width: "100%",
                      height: 200,
                      objectFit: "contain",
                    }}
                  />
                </Box>
                <h3 style={{ fontWeight: 500, margin: "5px 0" }}>
                  {order.book?.book_title}
                </h3>
                {order.book_price?.digital_price ? (
                  <p
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "5px",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Button
                      onClick={() =>
                        history.push(`/book/${order.book._id}/read`)
                      }
                      variant="contained"
                      style={{ marginTop: "12px" }}
                    >
                      READ
                    </Button>
                    <Button
                      onClick={() => handleDownload(order?.book?.pdf_file)}
                      variant="contained"
                      style={{ marginTop: "12px" }}
                    >
                      <Download />
                    </Button>
                  </p>
                ) : (
                  <p>Your Book is delivered to Your Address</p>
                )}
              </Paper>
            </Link>
          </Grid>
        ))}
      </Grid>
      {books.length > booksPerPage && (
        <Box display="flex" justifyContent="center" mt={4}>
          <Pagination
            count={Math.ceil(books.length / booksPerPage)}
            page={currentPage}
            onChange={handlePageChange}
            sx={{
              "& .MuiPaginationItem-root": {
                "&:hover": {
                  backgroundColor: "#FECE00",
                },
              },
              "& .Mui-selected": {
                backgroundColor: "#FECE00",
                color: "#000",
              },
              "& .MuiPaginationItem-ellipsis": {
                color: "#FECE00",
              },
            }}
          />
        </Box>
      )}
    </>
  ) : (
    <Box display="flex" justifyContent="center" alignItems="center" mt={4}>
      <h3 style={{ color: "red" }}>No books found. Please explore and purchase books!</h3>
    </Box>
  )}
</div>

  );
}

export default Books;
